import { linkFormatter } from '@crehana/i18n';
import { CUSTOM_GENERATEAI } from "../../constants";
import { useTranslation } from "../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var Custom = function Custom() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx("ul", {
    className: "tw-font-body4 tw-m-auto [&>*:last-child]:tw-pb-1.6",
    children: CUSTOM_GENERATEAI.map(function (_ref, i) {
      var label = _ref.label;
      return (
        /*#__PURE__*/
        // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
        _jsx("li", {
          className: "tw-list-disc tw-py-[0.1rem]",
          children: t(label, {
            formatter: function formatter(text) {
              return linkFormatter({
                text: text,
                className: 'text-secondary-light',
                targetBlank: true
              });
            }
          })
        }, "custom_".concat(i * 1))
      );
    })
  });
};
export default Custom;